<template>
  <div>
    <div class="myspinner">
      <atom-spinner
        v-if="loading"
        :animation-duration="speed"
        :size="config.size"
        :color="spinnersColor"
      />
    </div>
    <form @submit.prevent="onsubmit" class="login">
        <va-input
          v-model="form.memb_no"
          type="text"
          :label="$t('auth.memb_no')"
          :error="!!membNoErrors.length"
          :error-messages="membNoErrors"
        />

        <va-input
          v-model="form.phone_no"
          type="text"
          :label="$t('auth.phone_no')"
          :error="!!phoneNoErrors.length"
          :error-messages="phoneNoErrors"
        />     
      <div class="row justify--center">
        <va-button type="submit" :disabled="disableButton"  class="my-0">{{ $t('auth.reset_password') }}</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import * as spinners from 'epic-spinners'
export default {
  components: {
    ...spinners      
  },
  name: 'recover-password',
  data () {
    return {
      loading:false,
      disableButton:false,
      form:{
        memb_no:'',
        phone_no: '',
      },
      phoneNoErrors: [],
      membNoErrors: [],
      config: {
        size: 80,
        duration: 1500,
      },
      spinnersColor: "#df902a",
      currentDuration: 1500,
      sliderDuration: {
        min: 1000,
        max: 2000,
      },
    }
  },
  computed: {
    speed () {
      return this.sliderDuration.min + this.sliderDuration.max - this.currentDuration
    },
    formReady () {
      return  !this.phoneNoErrors.length  && !this.membNoErrors.length
    },
  },
  methods: {
    onsubmit () {
      this.membNoErrors = this.form.memb_no ? [] : ['Member No. field is required']
      this.phoneNoErrors = this.form.phone_no ? [] : ['Phone No. is required']

      if (this.formReady) {
        var self = this 
        self.loading = true;  
        self.disableButton = true;   
        axios.post(`${this.$apiUrl}RequestPin/113`, this.form)
        .then(function (res) {
          self.loading = false;  
          self.disableButton = false; 
          var response = res.data
          //console.log(response.success);
          if (response.success === 1) {              
              self.showToast(`Successful! Your pin has been successfully reset and sent to your phone. Please login and update your pin once you get it`, {
                position: 'bottom-right',
                icon: "fa-check",
                duration: 10000,
              })
              setTimeout( () => self.showOTP = false, 300000);
              self.$router.push({name: "login" });
          }

          if (response.success === 2) {
            self.membNoErrors = ['Account Not Found!']
            self.showToast(`Account Not Found! Confirm Your Member No and Phone NO or dial +254705951672 for PIN Reset assistance.`, {
              position: 'bottom-right',
              icon: "fa-times",
              duration: 100000,
            })
          } 

          if (response.success === 3) {
            self.membNoErrors = ['Account is Mobile banking enabled!']
            self.showToast(`Could not complete pin reset due to security reasons please dial +254705951672 for PIN Reset assistance.`, {
              position: 'bottom-right',
              icon: "fa-times",
              duration: 100000,
            })
          } 

        })
        .catch(function (error) {
          console.log(error)
        })
        
      }

    },
  },
}
</script>

<style lang="scss">
.myspinner {
  position: fixed;
  top: 40%;
  left: 22%;
  z-index: 999;
}

@media (max-width: 767px) {
  .myspinner {
    position: fixed;
    top: 38%;
    left: 40%;
    z-index: 999;
  }
}
</style>
